export default "__VITE_ASSET__wXRSSyHr__"